import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
import { Suspense, lazy, useMemo } from "react";
//#region src/use-consultant-route.tsx
var LazyConsultantRoute = lazy(() => import("./consultant-route-DbyopYra.js").then((n) => n.n).then((module) => ({ default: module.ConsultantRoute })));
function ConsultantRoute({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "consultant-route" }),
		children: /* @__PURE__ */ jsx(LazyConsultantRoute, { ...props })
	});
}
var useConsultantRoute = () => {
	return useMemo(() => ({ "consultant-route": { component: ConsultantRoute } }), []);
};
//#endregion
export { useConsultantRoute };
